__turbopack_context__.v({
  "error": "InputStateMessage-module-scss-module__QCGglW__error",
  "fade-in": "InputStateMessage-module-scss-module__QCGglW__fade-in",
  "message": "InputStateMessage-module-scss-module__QCGglW__message",
  "no-transform": "InputStateMessage-module-scss-module__QCGglW__no-transform",
  "rotate": "InputStateMessage-module-scss-module__QCGglW__rotate",
  "success": "InputStateMessage-module-scss-module__QCGglW__success",
});
